module.exports = __webpack_public_path__ + "static/thumbnail-a1f0e74f6d8ebc01d08695bc438da15c.png";